import { MessageItem } from '@app/models'

const getMessageIdentity = (message: MessageItem): string => {
  if (message.id > 0) {
    return `id:${message.id}`
  }

  if (message.uuid) {
    return `uuid:${message.uuid}`
  }

  return `fallback:${message.acsChatMessageId}:${message.creationDate}`
}

export const ensureUniqueMessages = (
  messages: MessageItem[]
): MessageItem[] => {
  const seen = new Set<string>()

  return messages.filter((message) => {
    const identity = getMessageIdentity(message)

    if (seen.has(identity)) {
      return false
    }

    seen.add(identity)
    return true
  })
}